export const ZERO_AS_DEFAULT = 1;
export const ZERO_AS_HIDDEN = 2;
export const ZERO_AS_FREE = 3;
export const ZERO_AS_INCLUDED = 4;
